import React, { useEffect, useState } from "react";

export const Imagen = ({ id }) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(
          `https://portaltransaccionalback.azurewebsites.net/api/ObtenerImagen/${id}`
        );

        if (!response.ok) {
          throw new Error("No se pudo obtener la imagen");
        }

        const url = await response.text();
        if (url.trim()) {
          setImageUrl(url);
        } else {
          setImageUrl(null);
        }
      } catch (error) {
        console.error("Error al cargar la imagen:", error);
        setImageUrl(null);
      }
    };

    fetchImage();
  }, [id]);

  if (!imageUrl) return null; // No renderiza nada si no hay imagen

  return (
    <img
      src={imageUrl}
      alt="Imagen"
      style={{
        width: "600px",
        height: "200px",
      }}
    />
  );
};
